import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalConfig } from '../models/modalConfig';
import { UploadReqWorkFlowStepWarningModalComponent } from 'src/app/pages/mission-control-page/upload-req-page/upload-req-work-flow-step-warning-modal/upload-req-work-flow-step-warning-modal.component';

@Injectable({
  providedIn: 'root'
})
export class UploadReqWorkFlowStepWarningModalService {

  workFlowStepWarningModal!: BsModalRef;

  constructor(private bsModalService: BsModalService) { }

  show(message: string, stepName: string): void {
    const config = new ModalConfig();
    config.class = 'modal-sm four-dot-five-modal-small';
    config.initialState = { message, stepName };
    this.workFlowStepWarningModal = this.bsModalService.show(UploadReqWorkFlowStepWarningModalComponent, config);
  }
}
